import { supabase } from '@/lib/supabase';

/**
 * TEST / TRAINING ACCOUNTS
 * Accounts listed in mkt_test_accounts are practice accounts for the team.
 * Server-side they are sandboxed (their listings are hidden from the public
 * marketplace, and they can only unlock [TRAINING] listings). Client-side we
 * label them everywhere and block every real-money checkout path.
 */

export const TRAINING_PAYMENT_BLOCKED = 'training_account_no_payments';

export const TRAINING_PAYMENT_MESSAGE = {
  en: 'This is a TEST/TRAINING account. Real card payments are turned off. Use your demo credits to unlock [TRAINING] projects instead.',
  es: 'Esta es una cuenta de PRUEBA/CAPACITACIÓN. Los pagos con tarjeta real están desactivados. Usa tus créditos de demostración para desbloquear proyectos [TRAINING].',
};

const cache = new Map<string, boolean>();

export const isTrainingAccount = async (userId?: string | null): Promise<boolean> => {
  if (!userId) return false;
  if (cache.has(userId)) return cache.get(userId)!;
  const { data } = await supabase.from('mkt_test_accounts').select('user_id').eq('user_id', userId).maybeSingle();
  const yes = !!data;
  cache.set(userId, yes);
  return yes;
};

/** For code paths without a user in hand (lib helpers). */
export const currentUserIsTraining = async (): Promise<boolean> => {
  const { data } = await supabase.auth.getUser();
  return isTrainingAccount(data?.user?.id);
};
